import { initialize } from 'ldclient-js';
import Environment from './environment';

const launchDarklyClientSideIds = {};
launchDarklyClientSideIds[Environment.author()]     = '5b68d7945224d91ec756e99e';
launchDarklyClientSideIds[Environment.dev()]        = '5b67f29a5d5baf1ebf608fa8';
launchDarklyClientSideIds[Environment.staging()]    = '5b68d78749aaf91ec915c0e9';
launchDarklyClientSideIds[Environment.production()] = '5b67f29a5d5baf1ebf608fa9';

let env = Environment.getEnvironment();

// Normally "author" is considered a "staging" environment,
// but for this, we want to make the distinction.
if (Environment.isAuthor()) {
  env = Environment.author();
}

const WAC_CLIENT_SIDE_ID = launchDarklyClientSideIds[env];

class WacLDClient {
  constructor(user = {
    key: 'anonymous-wac-user',
    anonymous: true
  }) {

    return initialize(WAC_CLIENT_SIDE_ID, user);
  }
}

export default WacLDClient;
